import { Observable } from 'rxjs'
import AxiosSubscriber from '../../factory/AxiosSubscriber'

export class MentionByOrderAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(orderId, next, complete, error, isCMReview = false) {
    const token = localStorage.getItem('token')
    const httpConfig = {
      url: `/order/${orderId}/mentions?cm-revew=${isCMReview}`,
      method: 'get',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig)
    })

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error,
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}
